import { FilterConfig } from '@/types/filter';
import { FilterValue } from '@/models';

import { HCP_SCIENTIFIC_ACTIVITY_SOCIAL_MEDIA } from '@/api/hcp';

import Stars from '@/components/shared/rating/Stars/Stars';

const socialMediaFilter: FilterConfig = {
  label: 'global.filters.formControls.socialMediaLabel',
  placeholder: 'global.filters.formControls.socialMediaPlaceholder',
  defaultValue: null,
  type: 'levelselect',
  format: ({ value, t }) => (
    <>
      <span>{t('global.filters.socialMedia')}</span>
      <Stars value={Number(value)} />
    </>
  ),
  filterGroup: 'scientificActivities',
  applyFilter: (value: FilterValue) => {
    const ratingScore = Number(value) || 0;
    return {
      and: [
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SOCIAL_MEDIA}.score_label`,
          operator: 'equals',
          values: ['national score'],
        },
        {
          member: `${HCP_SCIENTIFIC_ACTIVITY_SOCIAL_MEDIA}.score_value`,
          operator: 'gte',
          values: [ratingScore.toString()],
        },
      ],
    };
  },
};

export default socialMediaFilter;
